<template>
  <div class="speaker-card" :class="{ keynote: data.is_keynote }">
    <img
      :src="imageSrc"
      :alt="data.bio.first_name + data.bio.last_name"
      class="speaker-card__image"
    />
    <div v-show="data.is_keynote" class="badge">Keynote</div>
    <div class="speaker-card__text">
      <h4 class="speaker-card__text-name">
        {{ data.bio.first_name }} {{ data.bio.last_name }}
      </h4>
      <div class="speaker-card__text-org">
        {{ data.bio.organization }}
      </div>
      <!-- <div class="d-flex">
      <img
        :src="imageSrc"
        :alt="data.bio.first_name + data.bio.last_name"
        class="speaker-card__image"
        :class="{ 'first-img': data.add_bios?.length }"
      />
      <div class="speaker-card__text">
        <h4 class="speaker-card__text-name">
          {{ data.bio.first_name }} {{ data.bio.last_name }}
        </h4>
        <div class="speaker-card__text-org">
          {{ data.bio.organization }}
        </div>
      </div>
      <div v-if="data.add_bios && data.add_bios.length">
        <div
          v-for="addSpeaker in data.add_bios"
          :key="addSpeaker.id"
          :class="{ keynote: addSpeaker.is_keynote }"
          style="position: relative"
        >
          <img
            :src="
              addSpeaker.image
                ? addSpeaker.image
                : require('@/assets/img/empty-speaker.jpg')
            "
            :alt="addSpeaker.first_name + addSpeaker.last_name"
            class="speaker-card__image second-img"
          />
          <div class="speaker-card__text">
            <h4 class="speaker-card__text-name">
              {{ addSpeaker.first_name }}
              {{ addSpeaker.last_name }}
            </h4>
            <div class="speaker-card__text-org">
              {{ addSpeaker.organization }}
            </div>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "TalkCard",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    imageSrc() {
      return this.data.bio.image
        ? this.data.bio.image
        : require("@/assets/img/empty-speaker.jpg");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables";

.speaker-card {
  position: relative;
  width: 295px;
  background: $gray;
  border-radius: 10px;
  margin-right: 32px;
  margin-bottom: 32px;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 320px;
    background: linear-gradient(180deg, rgba(21, 21, 21, 0) 0%, #151515 100%);
  }

  &__image {
    border-radius: 10px;
    width: 100%;
    height: 320px;
    object-fit: cover;
    object-position: center;
    display: block;
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
  }

  &__text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 320px;
    padding: 0 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    z-index: 1;
    letter-spacing: 0.05em;
    line-height: 32px;
    font-weight: bold;
    border-radius: 10px;

    &-name {
      font-family: $Oswald;
      text-transform: uppercase;
      font-size: 24px;
    }

    &-org {
      opacity: 0.6;
      margin-bottom: 5px;
    }
  }
}

.keynote {
  border: 1px solid $red;
}

.badge {
  padding: 7px;
  position: absolute;
  top: 0;
  right: 0;
  width: 84px;
  height: 33px;
  background-color: $red;
  border-radius: 10px;
  font-size: 18px;
  line-height: 15px;
  z-index: 1;
}

/* .first-img {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.second-img {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
} */
</style>
